import React from "react";
import Login from "./Auth/Login/index";
import { Routes, Route } from "react-router-dom";
import ReactDOM from "react-dom";
import BrowserRouter from "react-router-dom";
import RouterComp from "./routers/Routes";
import { AuthContextProvider } from "../src/Context/AuthContext";
import "./App.css";
function Index() {
  return (
    <AuthContextProvider>
      <RouterComp />
      
    </AuthContextProvider>
    // <div className="main_app">
    //   <img
    //     src="https://c8.alamy.com/comp/2B77M01/3d-web-page-under-construction-concept-2B77M01.jpg"
    //     alt="under maintanence"
    //   />
    // </div>
  );
}

export default Index;

// const doc = new jsPDF({
//   orientation: "landscape",
//   unit: "px",
//   format: "a4",
// });

// doc.addImage(
//   canvas.toDataURL("image/png"),
//   "PNG",
//   0,
//   0,
//   doc.internal.pageSize.getWidth(),
//   doc.internal.pageSize.getHeight()
// );

// doc.save("document.pdf");
